import { Error500 } from "../../../alerts/Error";
import WhmcsApi from "../../WhmcsApi";

export const addOrderSaF = async ({ products, token, facturacionAutomatica = false, nbps = false, promocode = "", callbackError = () => {} }) => {
  try {
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
    const response = await whmcsApi.request(
      "addOrderSaF",
      {
        products: JSON.stringify(products),
        facturacionAutomatica,
        nbps,
        promocode,
      },
      "POST",
      token
    );

    return response;
  } catch (error) {
    console.error("Failed to Add Order:", error);
    Error500();
    callbackError();
    return false;
  }
};
